"use client";

import { HallowABFlag, useMixpanel } from "@packages/ab";
import { PushSubscriptionProvider } from "@packages/notifications";
import type { ReactNode } from "react";

// Keeps the web_notifications Mixpanel flag check out of @packages/notifications
// (which stays flag-agnostic) while still hiding all push-notification
// background activity — not just the UI — from anyone not targeted.
export const NotificationsProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { flags } = useMixpanel();
  const isEnabled = flags?.[HallowABFlag.WebNotifications]?.isTargeted ?? false;

  return (
    <PushSubscriptionProvider enabled={isEnabled}>
      {children}
    </PushSubscriptionProvider>
  );
};
